import { sendGenericEvent } from 'analytics/events/generics/sendGenericEvent'

import { ReturnsGenericEvents } from './constants'

export const sendOnClickDroppoint = () =>
	sendGenericEvent(ReturnsGenericEvents.RETURN_DROPPOINT)

export const sendOnClickHomePickUp = () =>
	sendGenericEvent(ReturnsGenericEvents.RETURN_HOME_PICKUP)

export const sendOnClickReturnStore = () =>
	sendGenericEvent(ReturnsGenericEvents.RETURN_STORE)
